import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ShieldCheck, HandHeart, Sparkles, Heart, Globe2 } from "lucide-react";
import Seo from "../components/Seo";

const VOLUNTEERS = "https://images.unsplash.com/photo-1593113616828-6f22bca04804?crop=entropy&cs=srgb&fm=jpg&w=1400&q=75";

export default function About() {
  return (
    <div>
      <Seo
        title="About us"
        description="Dkarez Community Support CIC is on a mission to bring transparency, dignity and grace to community-led fundraising."
      />
      <section className="max-w-6xl mx-auto px-4 sm:px-8 py-20 sm:py-24">
        <motion.div initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
          <span className="eyebrow">Our mission</span>
          <h1 className="font-serif-display text-5xl sm:text-6xl mt-4 leading-[1.05] max-w-3xl">
            Compassion, designed to <span className="italic text-brand-primary">scale globally</span>.
          </h1>
          <p className="mt-7 text-lg text-brand-muted max-w-3xl leading-relaxed">
            Dkarez Community Support CIC is a community interest company on a quest to bring transparency,
            dignity and grace to community-led fundraising. We exist to ensure every story finds a hand to hold.
          </p>
        </motion.div>
      </section>

      <section className="max-w-6xl mx-auto px-4 sm:px-8 pb-24">
        <div className="rounded-3xl overflow-hidden">
          <img src={VOLUNTEERS} alt="Volunteers helping community" className="w-full h-72 sm:h-[460px] object-cover" />
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 sm:px-8 pb-24 grid grid-cols-1 md:grid-cols-3 gap-7">
        {[
          { Icon: ShieldCheck, t: "Trust by design", d: "Every campaign is reviewed and tagged with a verification level. Trust scores grow with proof." },
          { Icon: HandHeart, t: "People-first", d: "We obsess over the lived experience of requesters and donors alike — never the metrics." },
          { Icon: Globe2, t: "Built to scale", d: "An architecture ready for milestone escrow, AI fraud detection, and multi-currency global reach." },
        ].map((v) => (
          <motion.div key={v.t}
            initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.5 }} className="premium-card p-8">
            <v.Icon size={24} strokeWidth={1.4} className="text-brand-primary" />
            <h3 className="font-serif-display text-2xl mt-3">{v.t}</h3>
            <p className="text-brand-muted mt-2 leading-relaxed">{v.d}</p>
          </motion.div>
        ))}
      </section>

      <section className="max-w-6xl mx-auto px-4 sm:px-8 pb-28">
        <div className="premium-card p-10 sm:p-14 text-center">
          <Sparkles className="mx-auto text-brand-primary" size={28} strokeWidth={1.4} />
          <h2 className="font-serif-display text-4xl mt-4 leading-tight">A simple promise.</h2>
          <p className="mt-4 text-brand-muted max-w-2xl mx-auto leading-relaxed">
            We believe a community thrives when its most vulnerable are seen, heard and supported.
            Dkarez exists to make that visible — beautifully.
          </p>
          <div className="mt-8">
            <Link to="/campaigns" className="btn-gold">
              <Heart size={16} className="mr-2" strokeWidth={1.8} /> Find a campaign to support
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
